import React, { ReactElement } from 'react';
import {
  useDispatch,
  // useSelector
} from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logout } from '../store/actions/authAction';
import { doctorsImages, saveDoctorsList } from '../store/actions/inventoryAction';
import ApplicationDetails from '../shared/services/applicationDetail.service';
import { setLookUpValues, clearPayerLookUp } from '../store/actions/lookUpAction';
import { clearApplicationDetails } from '../store/actions/applicationDetailAction';
import { hospitalLogo } from '../store/actions/hospitalAction';
// import AskNotificationPermission from '../utils/AskNotificationPermission';
// import {RootState} from '../store';

const Logout = (): ReactElement => {
  const applicationDetail = ApplicationDetails.instance;
  const dispatch = useDispatch();
  // const isAuthenticated = useSelector(({ auth }: RootState): boolean => {
  //   return !!auth.token;
  // });

    // AskNotificationPermission('logout', isAuthenticated).then((): void => {
      dispatch(logout());
      dispatch(doctorsImages(null));
      dispatch(setLookUpValues({
        pastHistory: [], proposedLineOfTreatment: [], diagnosisType: [], designation: [], relation: [],
        badTreatment: [], badDiagnosis: [], courierService: [],
      }));
      dispatch(clearPayerLookUp());
      dispatch(hospitalLogo(null));
      applicationDetail.setApplicationDetail({});
      dispatch(clearApplicationDetails());
      dispatch(saveDoctorsList(null));
    // });
  return (
    <Redirect to="/"/>
  );
};

export default Logout;
